import { render, staticRenderFns } from "./video-tab-table.vue?vue&type=template&id=e51dbcce&"
import script from "./video-tab-table.vue?vue&type=script&lang=js&"
export * from "./video-tab-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports